/**
 * Market hours utility - determines if the US stock market is open.
 */

/**
 * Check if the US stock market is currently open.
 * Market hours: Mon-Fri 9:30 AM - 4:00 PM Eastern Time.
 */
export function isMarketOpen(): boolean {
  const now = new Date();
  // Convert to Eastern Time
  const et = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
  const day = et.getDay();
  const hour = et.getHours();
  const min = et.getMinutes();

  // Weekend
  if (day === 0 || day === 6) return false;

  const minuteOfDay = hour * 60 + min;
  // 9:30 AM = 570, 4:00 PM = 960
  return minuteOfDay >= 570 && minuteOfDay < 960;
}

/**
 * Get a human-readable market status string.
 */
export function getMarketStatus(): 'open' | 'closed' | 'pre-market' | 'after-hours' {
  const now = new Date();
  const et = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
  const day = et.getDay();
  const hour = et.getHours();
  const min = et.getMinutes();

  if (day === 0 || day === 6) return 'closed';

  const minuteOfDay = hour * 60 + min;

  if (minuteOfDay >= 570 && minuteOfDay < 960) return 'open';
  if (minuteOfDay >= 240 && minuteOfDay < 570) return 'pre-market'; // 4:00 AM - 9:30 AM
  if (minuteOfDay >= 960 && minuteOfDay < 1200) return 'after-hours'; // 4:00 PM - 8:00 PM
  return 'closed';
}
